// STYLES
const styles = {
    container: {
      fontFamily: "sans-serif",
      maxWidth: 500,
      margin: "0 auto",
      padding: "1rem",
      position: "relative",
      overflowX: "hidden",
    },
    sidebar: {
      position: "absolute",
      top: 0,
      right: 0,
      width: "200px",
      height: "100vh",
      backgroundColor: "#fff",
      // boxShadow: "-2px 0 5px rgba(0,0,0,0.3)",
      transition: "transform 0.3s ease-in-out",
      zIndex: 999,
      padding: "1rem",
    },
    content: {
      transition: "margin-right 0.3s ease-in-out",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "1rem",
    },
    menuButton: {
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
    },
    menuBar: {
      width: 25,
      height: 3,
      backgroundColor: "#333",
      margin: "4px 0",
    },
    highlightContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      marginBottom: "1rem",
    },
    highlightBox: {
      backgroundColor: "#333",
      color: "#fff",
      padding: "0.5rem",
      borderRadius: 4,
    },
    chartSection: {
      marginBottom: "2rem",
    },
    chartWrapper: {
      width: "100%",
      height: "250px",
    },
    closeButton: {
      background: "none",
      border: "1px solid #ccc",
      padding: "0.25rem 0.5rem",
      cursor: "pointer",
      marginBottom: "1rem",
    },
  };

  export default styles;